// extracted by mini-css-extract-plugin
export default {"box":"Loader_box__wORI1"};